export class RegionListFilter {

  constructor() { }

  name: string;
}



// WEBPACK FOOTER //
// ./src/app/modules/other-kp/models/regions-list-filter.ts